import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=6010b9fd&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./Edit.vue?vue&type=style&index=0&id=6010b9fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6010b9fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6010b9fd')) {
      api.createRecord('6010b9fd', component.options)
    } else {
      api.reload('6010b9fd', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=6010b9fd&scoped=true&", function () {
      api.rerender('6010b9fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/game/Edit.vue"
export default component.exports